import { combineReducers } from 'redux'
import theme from './theme/themeSlice'
import auth from './auth'
import base from './base'
import locale from './locale/localeSlice'
import common from './commonReducer'
import product from './product.reducer'
import user from './user.reducer'
import cart from './cartReducer'
import report from './reportReducer'
import job from './jobReducer'
import promotion from './promotionReducer'
import setting from './setting.reducer'
import service from './service.reducer'
import order from './order.reducer'
import finance from './finance.reducer'

const rootReducer = (asyncReducers) => (state, action) => {
    const combinedReducer = combineReducers({
        theme,
        auth,
        base,
        locale,
        common,
        service,
        user,
        cart,
        report,
        job,
        promotion,
        setting,
        product,
        order,
        finance,
        ...asyncReducers,
    })
    return combinedReducer(state, action)
}

export default rootReducer
